import { render } from "./MovingDiv.vue?vue&type=template&id=441a15d0&scoped=true"
const script = {}

import "./MovingDiv.vue?vue&type=style&index=0&id=441a15d0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441a15d0"]])

export default __exports__